<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
                custom-css="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/custom_upload_overrides.css"
          :language="$t('Language')"></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled">
        <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
          :show-confirmation="show_confirmation"
             custom-css="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/custom_upload_overrides.css"
          :is-logged-out="is_logged_out" @is-registered="handleIsRegistered"
          :language="$t('Language')"></snipp-registration>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again'">
        <br />
        <h3>{{ $t('IPEwidget.ThanksTitle') }} </h3>
        <p v-html="$t('IPEwidget.ThanksDesc')">
        </p>
        <p v-html="$t('IPEwidget.TermsLink')"></p>
        <br />
      </div>
      <div id="upload-wrapper" v-if="upload_enabled">
        <div class="upload-container upload-custom">
          <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
            <h2 class="text-center upload-main-heading my-4">{{ $t('IPEwidget.UploadReceiptTitle') }}</h2>
            
            <!-- Three Tip Cards -->
            <div class="container">
            <div class="row tip-cards-row justify-content-center mb-5">
              <!-- Tip 1 -->
              <div class="col-md-4 mb-4">
                <div class="tip-card">
                  <div class="tip-icon-wrapper mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .5 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path><line x1="9" y1="18" x2="15" y2="18"></line><line x1="10" y1="22" x2="14" y2="22"></line></svg>
                  </div>
                  <h4 class="tip-card-title">{{ $t('IPEwidget.Tip1Title') }}</h4>
                  <p class="tip-card-desc">{{ $t('IPEwidget.Tip1Desc') }}</p>
                </div>
              </div>
              
              <!-- Tip 2 -->
              <div class="col-md-4 mb-4">
                <div class="tip-card">
                  <div class="tip-icon-wrapper mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>
                  </div>
                  <h4 class="tip-card-title">{{ $t('IPEwidget.Tip2Title') }}</h4>
                  <p class="tip-card-desc">{{ $t('IPEwidget.Tip2Desc') }}</p>
                </div>
              </div>
              
              <!-- Tip 3 -->
              <div class="col-md-4 mb-4">
                <div class="tip-card">
                  <div class="tip-icon-wrapper mb-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                  </div>
                  <h4 class="tip-card-title">{{ $t('IPEwidget.Tip3Title') }}</h4>
                  <p class="tip-card-desc">{{ $t('IPEwidget.Tip3Desc') }}</p>
                </div>
              </div>
            </div>

            <!-- Uploader Area -->
            <div class="uploader-container mb-4">
              <snipp-upload :campaign-id="campaignId" include-upload-button="false"
                @snipp-upload-result="handleSnippUploadResult"
                      custom-css="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/custom_upload_overrides.css"
                :language="$t('Language')"></snipp-upload>
            </div>
            </div>
            
            <!-- Online Purchases Instructions -->
            <p class="online-purchases-text text-center mb-5" v-html="$t('IPEwidget.OnlinePurchases')"></p>
            
            <!-- Receipt Must Include Section -->
            <section class="receipt-requirements-section text-center py-5 mb-4" :style="{ backgroundImage: 'url(' + $t('Home.HtwBgDesktop') + ')' }">
              <div class="container py-3">
                <h2 class="requirements-heading mb-4 text-white">{{ $t('IPEwidget.MustIncludeTitle') }}</h2>
                <div class="row justify-content-center requirements-grid px-3">
                  <!-- Check 1: Store Name -->
                  <div class="col-md-6 mb-4">
                    <div class="requirement-item d-flex align-items-center">
                      <div class="check-icon-container me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                      <span class="requirement-text text-white">{{ $t('IPEwidget.MustIncludeStoreName') }}</span>
                    </div>
                  </div>
                  
                  <!-- Check 2: Purchases -->
                  <div class="col-md-6 mb-4">
                    <div class="requirement-item d-flex align-items-center">
                      <div class="check-icon-container me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                      <span class="requirement-text text-white">{{ $t('IPEwidget.MustIncludePurchases') }}</span>
                    </div>
                  </div>

                  <!-- Check 3: Date -->
                  <div class="col-md-6 mb-4">
                    <div class="requirement-item d-flex align-items-center">
                      <div class="check-icon-container me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                      <span class="requirement-text text-white">{{ $t('IPEwidget.MustIncludeDate') }}</span>
                    </div>
                  </div>

                  <!-- Check 4: Total Cost -->
                  <div class="col-md-6 mb-4">
                    <div class="requirement-item d-flex align-items-center">
                      <div class="check-icon-container me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                      <span class="requirement-text text-white">{{ $t('IPEwidget.MustIncludeTotal') }}</span>
                    </div>
                  </div>

                  <!-- Check 5: Retailer Name -->
                  <div class="col-12 col-md-8 mb-4">
                    <div class="requirement-item d-flex align-items-center mx-auto" style="max-width: 600px;">
                      <div class="check-icon-container me-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                      <span class="requirement-text text-white">{{ $t('IPEwidget.MustIncludeRetailer') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div id="upload-again" v-if="upload_enabled === 'upload_again'">
            <snipp-upload :campaign-id="campaignId" include-upload-again-button="true"
              @snipp-upload-result="handleSnippUploadResult"
               custom-css="https://snippcheck.blob.core.windows.net/files/OffersDemoCampaign/custom_upload_overrides.css"
              :language="$t('Language')"></snipp-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: 'upload',
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
    };
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}

#current-user-wrapper {
  max-width: 70%;
  margin: 0 auto;
}

#upload-wrapper {
  width: 100%;
}

.uploader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

snipp-upload {
  display: block;
  width: 100%;
  margin: 0 auto;
}



.upload-main-heading {
  font-size: 2.25rem;
  font-weight: 700;
  color: #000000;
  margin-top: 1rem;
}

/* Tip Cards Styling */
.tip-cards-row {
  margin-top: 2.5rem;
}

.tip-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 2.25rem 2rem 2rem 2rem;
  min-height: 190px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
  height: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tip-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px -2px rgba(0, 0, 0, 0.06);
}

.tip-icon-wrapper {
  background-color: #2584C5;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
}

.tip-icon-wrapper svg {
  stroke: #ffffff;
}

.tip-card-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 0.5rem;
}

.tip-card-desc {
  font-size: 0.875rem;
  line-height: 1.5;
  color: #4a5568;
  margin-bottom: 0;
}

/* Online Purchases text */
.online-purchases-text {
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

.online-purchases-text :deep(a) {
  color: #2584C5 !important;
  text-decoration: underline !important;
  font-weight: 600;
}

.online-purchases-text :deep(a):hover {
  color: #1b6ca2 !important;
}

/* Receipt Requirements Section */
.receipt-requirements-section {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.receipt-requirements-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.35); /* Dark glass overlay */
  z-index: 1;
}

.receipt-requirements-section > .container {
  position: relative;
  z-index: 2;
}

.requirements-heading {
  font-size: 2.25rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.requirements-grid {
  margin: 0 auto;
}

.requirement-item {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 1.15rem 1.5rem;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  height: 100%;
}

.requirement-item:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.check-icon-container {
  background: #ffffff;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.check-icon-container svg {
  stroke: #2584C5;
}

.requirement-text {
  font-size: 1.1rem;
  font-weight: 700;
  text-align: left;
}

@media screen and (max-width: 767px) {
  .upload-main-heading {
    font-size: 1.85rem;
  }
  .requirements-heading {
    font-size: 1.85rem;
  }
}

@media screen and (max-width: 575px) {
  #current-user-wrapper {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>

<style>
body {
  overflow-x: hidden;
}
</style>
